export enum Permission {
  AssignFulfillments = 'assign_fulfillments',
  EditCheckoutAgreements = 'edit_checkout_agreements',
  EditClientRole = 'edit_client_role',
  EditEmbedConfigs = 'edit_embed_configs',
  EditFulfillments = 'edit_fulfillments',
  EditMenuCustomizations = 'edit_menu_customizations',
  EditPrinters = 'edit_printers',
  EditProducts = 'edit_products',
  /** @knipignore Knip has trouble detecting enum members not referred to explicitly. */
  EditReservations = 'edit_reservations',
  /** @knipignore */
  EditSms = 'edit_sms',
  EditSpecials = 'edit_specials',
  EditStaff = 'edit_staff',
  EditStore = 'edit_store',
  EditUnpublishedProducts = 'edit_unpublished_products',
  ViewAnalytics = 'view_analytics',
}
